import { render, staticRenderFns } from "./SectionBuilding.vue?vue&type=template&id=c1fb11aa&scoped=true&"
import script from "./SectionBuilding.vue?vue&type=script&lang=js&"
export * from "./SectionBuilding.vue?vue&type=script&lang=js&"
import style0 from "./SectionBuilding.vue?vue&type=style&index=0&id=c1fb11aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fb11aa",
  null
  
)

export default component.exports